import {AuthorizationListRowItem} from "./AuthorizationListRowItem";
import {AuthorizationListColumn, AuthorizationListQueryResponse} from "./ClientProfileAuthorizationPage";

import React from 'react';
import {ParentCaseAuthorizationListAction} from "./parentCaseAuthorizationReducer";
import {LoadingSpinner} from "../../common";

export type ClientProfileAuthorizationTableProps = {
    selectedAuthorizationGuid: string | null;
    authorizationListQueryResponse: AuthorizationListQueryResponse | undefined;
    loading: boolean;
    dispatch: React.Dispatch<ParentCaseAuthorizationListAction>;
}

export function ClientProfileAuthorizationTable({
                                                    authorizationListQueryResponse,
                                                    dispatch,
                                                    selectedAuthorizationGuid,
                                                    loading,
                                                }: ClientProfileAuthorizationTableProps) {
    return (
        <div className="w-full scrollbar-always flex-1 min-h-0">
            <table className='table table-fixed w-full'>
                <thead>
                <tr className='text-left select-none text-sm text-gray-portal-table-title'>
                    {
                        AuthorizationListColumn.map((column) => (
                            <th
                                key={column.attr}
                                className={'font-light' + (column.attr === 'bhpnAuthNumber' ? ' pl-4' : '')}
                                colSpan={column.span}
                            >
                                <div className='flex items-center'>
                                    <div>
                                        {column.name}
                                    </div>
                                </div>
                            </th>
                        ))
                    }
                </tr>
                </thead>
                <tbody>
                {
                    !loading && authorizationListQueryResponse!.edges.map((edge) => edge.node)
                        .map((authorization) =>
                            <AuthorizationListRowItem
                                key={authorization.guid}
                                authorization={authorization}
                                dispatch={dispatch}
                                selected={selectedAuthorizationGuid === authorization.guid}/>
                        )
                }
                </tbody>
            </table>
            {!loading && authorizationListQueryResponse!.edges.length === 0 &&
                <div className="text-center p-8 w-full">No authorizations available.</div>}
            {loading &&
                <div className="pt-16">
                    <LoadingSpinner spacing={20}/>
                </div>}
        </div>
    );
}